import { render, staticRenderFns } from "./FragmentAudio.vue?vue&type=template&id=04d09dab"
import script from "./FragmentAudio.vue?vue&type=script&lang=ts"
export * from "./FragmentAudio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports